import { useEffect, useState } from "react";
import { Link } from "wouter";
import { apiFetch } from "../lib/api.js";
import { usePaid } from "../components/PremiumLock.jsx";

export default function Record() {
  const isPaid = usePaid();
  const [dashboard, setDashboard] = useState(null);
  const [reviews, setReviews] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch("/dashboard").then(setDashboard).catch((e) => setError(e.message));
  }, []);

  useEffect(() => {
    if (!isPaid) return;
    apiFetch("/share/weekly-reviews").then(setReviews).catch((e) => setError(e.message));
  }, [isPaid]);

  return (
    <div className="page-wide">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        THE RECORD
      </div>
      <h1 style={{ marginBottom: 32 }}>What you have held</h1>

      {error && <p style={{ color: "var(--error)", marginBottom: 16 }}>{error}</p>}

      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
          <div className="card-title">Weeks held</div>
          <div className="mono" style={{ fontSize: 32 }}>{dashboard ? dashboard.weeksHeld : "…"}</div>
        </div>
        <p style={{ color: "var(--muted)", fontSize: 14, marginTop: 12, marginBottom: 0 }}>
          A week counts as held whenever you ran a weekly review or restored your floor that week.
        </p>
      </div>

      <div className="card" style={{ marginBottom: 24 }}>
        <div className="card-title" style={{ marginBottom: 16 }}>Review history</div>
        {!isPaid && (
          <p className="empty-state">Review history is part of Conquest Premium - coming soon.</p>
        )}
        {isPaid && reviews && reviews.length === 0 && (
          <p className="empty-state">No weekly reviews yet. Run one with your corner.</p>
        )}
        {isPaid && reviews && reviews.length > 0 && (
          <div className="hairline-list">
            {reviews.map((r) => (
              <div key={r.id} style={{ display: "flex", justifyContent: "space-between" }}>
                <span>Week of {new Date(r.weekOf).toLocaleDateString()}</span>
                <span className="mono" style={{ color: "var(--muted)" }}>{(r.big3 || []).length} Big 3 items</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="card-grid two-col">
        <div className="card">
          <div className="card-title" style={{ marginBottom: 8 }}>Insight report</div>
          <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 16 }}>
            How your Standing Check and pattern register have moved over time.
          </p>
          <Link href="/insight" className="btn-secondary" style={{ display: "inline-block", textDecoration: "none" }}>
            Open Insight
          </Link>
        </div>
        <div className="card">
          <div className="card-title" style={{ marginBottom: 8 }}>Exports</div>
          <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 16 }}>
            Field reports and a full structured export of your data.
          </p>
          <Link href="/exports" className="btn-secondary" style={{ display: "inline-block", textDecoration: "none" }}>
            Open Exports
          </Link>
        </div>
      </div>
    </div>
  );
}
